/* eslint-disable @typescript-eslint/naming-convention */
import i18next from 'i18next';

import type {
  IsoCheck, IsoMinMaxThreshold, IsoEnumThreshold, ChecksValueMapperByTypeReturn,
} from './types';

export const valueByType = {
  boolean: (v: boolean) => v,
  percent: (v: number | undefined) => (v === undefined ? undefined : (v * 100).toFixed(2)),
  degrees: (v: number) => v?.toFixed(2),
  pixels: (v: number) => v?.toFixed(),
  Mb: (v: number) => v?.toFixed(),
  number: (v: number) => (v === 0 ? 0 : v?.toFixed(4)),
  default: (v: { label: string }) => v?.label ?? i18next.t('monokit:create face modal.iso.no result value'),
} as const;

export const thresholdByType = {
  enum: (v: IsoEnumThreshold) => ({ value: v.map(({ label }) => label).join(', ') }),
  percent: (
    { min, max }: IsoMinMaxThreshold,
  ) => ({ min: (min * 100).toFixed(2), max: (max * 100).toFixed(2) }),
  min: (v: IsoMinMaxThreshold) => ({ value: v.min }),
  minMax: (v: IsoMinMaxThreshold) => ({ ...v }),
  bool: (v: boolean) => ({ value: v }),
  default: (v: unknown) => ({ value: v }),
} as const;

export const checksValueMapperByType = (values: IsoCheck): ChecksValueMapperByTypeReturn => {
  const {
    name, object_value, threshold_value, valueType, thresholdType,
  } = values;

  const checkName = i18next.t(`monokit:create face modal.iso.check name.${name}`);
  const checkValue = i18next.t('monokit:create face modal.iso.check result', { value: valueByType[valueType](object_value), context: valueType });
  const tooltipText = i18next.t('monokit:create face modal.iso.check tooltip', { context: thresholdType, ...thresholdByType[thresholdType](threshold_value) });
  const tableText = i18next.t('monokit:create face modal.iso.check table', { context: thresholdType, ...thresholdByType[thresholdType](threshold_value) });

  return {
    ...values, checkName, checkValue, tooltipText, tableText,
  };
};
